import React from 'react';

/**
 * Componente Switch para alternar entre estados
 * 
 * @param {boolean} checked - Estado atual do switch
 * @param {function} onChange - Função chamada quando o estado muda
 * @param {function} onCheckedChange - Função chamada quando o estado muda (compatibilidade)
 * @param {string} labelLeft - Texto à esquerda (opcional)
 * @param {string} labelRight - Texto à direita (opcional)
 * @param {string} className - Classes CSS adicionais
 */
const Switch = ({ 
  checked = false, 
  onChange,
  onCheckedChange, 
  labelLeft,
  labelRight,
  className = '', 
  ...props 
}) => {
  // Usar onChange se disponível, senão tentar usar onCheckedChange
  const handleChange = onChange || onCheckedChange || function() {};
  
  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      {labelLeft && (
        <span className={`text-sm ${checked ? 'text-gray-500' : 'font-medium'}`}>
          {labelLeft}
        </span>
      )}
      
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        onClick={() => handleChange(!checked)}
        className={`
          relative inline-flex h-6 w-11 items-center rounded-full
          transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
          ${checked ? 'bg-blue-600' : 'bg-gray-200'}
        `}
        {...props}
      >
        <span
          className={`
            inline-block h-4 w-4 rounded-full bg-white
            transform transition-transform
            ${checked ? 'translate-x-6' : 'translate-x-1'}
          `}
        />
      </button>
      
      {labelRight && (
        <span className={`text-sm ${checked ? 'font-medium' : 'text-gray-500'}`}>
          {labelRight}
        </span>
      )}
    </div>
  );
};

export default Switch; 